import React from 'react';
import { Helmet } from 'react-helmet-async';
import { COMPANY_INFO } from '../data/mockData';

export default function SEO({ title, description, slug = '', image, exact = false }) {
  const siteTitle = title 
    ? (exact || title.includes("K-TO") ? title : `${title} - ${COMPANY_INFO.brandName}`)
    : `${COMPANY_INFO.brandName} - Service & indregulering af ventilation`;

  const metaDesc = description || "K-TO Ventilationsteknik udfører service, indregulering, fejlfinding, reparation, montering og rensning af ventilationsanlæg for erhverv og industri på Fyn og i hele Jylland.";
  const canonicalUrl = `https://k-to-multiservice.dk${slug.startsWith('/') ? slug : `/${slug}`}`;
  const ogImage = image || "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-8-1024x683.jpg";

  const schemaOrg = {
    "@context": "https://schema.org",
    "@type": "HVACBusiness",
    "name": COMPANY_INFO.brandName,
    "legalName": COMPANY_INFO.legalName,
    "url": "https://k-to-multiservice.dk",
    "telephone": "+4522728723",
    "email": COMPANY_INFO.email,
    "vatID": COMPANY_INFO.cvr,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": COMPANY_INFO.address,
      "postalCode": "7080",
      "addressLocality": "Børkop",
      "addressCountry": "DK"
    },
    "areaServed": ["Jylland", "Fyn", "Vejle", "Fredericia", "Kolding"],
    "description": metaDesc
  };

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={metaDesc} />
      <link rel="canonical" href={canonicalUrl} />
      <html lang="da" />

      {/* Open Graph */}
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={COMPANY_INFO.brandName} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrg)}
      </script>
    </Helmet>
  );
}
